export default "__VITE_ASSET__BBExpTc4__"